<template>
  <questionnaire-add-mobile :url="url"></questionnaire-add-mobile>
</template>
<script>
import { mapActions } from "vuex";
import QuestionnaireAddMobile from "@/components/questionnaire/AddMobile";
export default {
  name: "add-questionnaire",
  components: {
    QuestionnaireAddMobile,
  },
  data() {
    return {
      url: location.origin,
    };
  },
  methods: {
    ...mapActions({
      checkLogin: "user/checkLogin",
    }),
  },
  mounted() {
    this.checkLogin({ followRedirect: true });
  },
};
</script>
